// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import LabeledCriteria from '../../../../shared/components/labeled-criteria';

const ClaimHistoryPinCriteria = props =>
    <div className='claim-history-pin-criteria'>
        <LabeledCriteria
            className='pin-criteria'
            isRequired={true}
            label='PIN'
            maxLength='17'
            onInputChange={props.handlePinInputChange}
            placeholder='PIN'
            type='text'
            value={props.pinValue}
        />
    </div>;

ClaimHistoryPinCriteria.displayName = 'ClaimHistoryPinCriteria';
ClaimHistoryPinCriteria.propTypes = {
    handlePinInputChange: PropTypes.func.isRequired,
    pinValue: PropTypes.string.isRequired
};

export default ClaimHistoryPinCriteria;




// WEBPACK FOOTER //
// ./src/reports/claim-history/components/claim-history-report-criteria/pin-criteria.js